// extracted by mini-css-extract-plugin
export default {"page":"vR-z","cartModal":"wR-z","checkout":"xR-z","placeholder":"yR-z","account":"zR-z"};